import { DeviceInput, ExtensionInput, ExtensionPhoneInput, MailboxInput, PhoneInput } from 'generated/graphql-types';
import { BulkExtensionDetailSaveEvent } from '../models/bulk-configure-extensions-form-submit';

export function createExtensionsInput(
   extensionsSave: BulkExtensionDetailSaveEvent[],
   extensionFields: (keyof ExtensionInput)[],
   mailboxFields: (keyof MailboxInput)[],
   extensionPhoneFields: (keyof ExtensionPhoneInput)[],
   phoneFields: (keyof PhoneInput)[],
   devicesFields: (keyof DeviceInput)[]
): ExtensionInput[] {
   formatEmbeddedMailboxFields(extensionFields, 'mailbox', mailboxFields);

   formatExtensionEmbeddedPhoneFields(
      extensionFields,
      'extensionPhone',
      extensionPhoneFields,
      phoneFields,
      devicesFields
   );
   let extensionsInput: ExtensionInput[] = [];
   extensionsSave.forEach((ext) => {
      const mailbox: MailboxInput = { emailAddress: ext.emailAddress, fields: mailboxFields };
      const devices: DeviceInput[] = [{ deviceId: ext.deviceId, fields: devicesFields }];
      const phones: PhoneInput[] = [{ phoneType: ext.phoneType, devices: devices, numberOfLineKeys: ext.numberOfLineKeys, fields: phoneFields }];
      const extensionPhone: ExtensionPhoneInput = {
         displayName: ext.displayName,
         ringTimeout: ext.ringTimeout,
         defaultPhoneNumberId: ext.defaultPhoneNumberId,
         phones: phones,
         fields: extensionPhoneFields,
      };
      const extension: ExtensionInput = {
         name: ext.name,
         number: ext.number,
         accountId: ext.accountId,
         type: ext.extensionType,
         mailbox: mailbox,
         extensionPhone: extensionPhone,
         fields: extensionFields,
      };
      extensionsInput.push(extension);
   });
   return extensionsInput;
}

type MailboxEmbedFieldExtension = keyof MailboxInput;
function formatEmbeddedMailboxFields(fields: string[], key: string, embedFields: MailboxEmbedFieldExtension[]) {
   if (key) {
      for (const embedField of embedFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}
type ExtensionEmbedFieldExtensionPhone = keyof ExtensionPhoneInput;
type ExtensionPhoneEmbedFieldPhone = keyof PhoneInput;
type PhoneEmbedFieldDevice = keyof DeviceInput;
function formatExtensionEmbeddedPhoneFields(
   fields: string[],
   key: string,
   embedExtensionPhoneFields: ExtensionEmbedFieldExtensionPhone[],
   embedPhoneFields: ExtensionPhoneEmbedFieldPhone[],
   embedDevicesFields: PhoneEmbedFieldDevice[]
) {
   if (key) {
      for (const embedField of embedExtensionPhoneFields) {
         fields.push(`${key}.${embedField}`);
         const phonesIndex = fields.indexOf(`${key}.phones`);
         if (phonesIndex > -1) {
            fields.splice(phonesIndex, 1);
            fields.push(
               ...embedPhoneFields.map((keyField) => {
                  return `${key}.${embedField}.${keyField}`;
               })
            );
            const deviceIndex = fields.indexOf(`${key}.${embedField}.devices`);
            if (deviceIndex > -1) {
               fields.splice(deviceIndex, 1);
               fields.push(
                  ...embedDevicesFields.map((deviceField) => {
                     return `${key}.${embedField}.devices.${deviceField}`;
                  })
               );
            }
         }
      }
   }
}
